var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thecard"},[_c('div',{staticClass:"thefront",class:{'thefrontClicked':_vm.cardClicked},on:{"click":function($event){return _vm.showModal(_vm.index)}}}),_c('div',{staticClass:"theback"},[_c('h1',{on:{"click":function($event){return _vm.showModal(_vm.index)}}},[_vm._v("Confirm")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }